module.exports = __webpack_public_path__ + "img/walking-steps.e91cd80a.svg";